





































import Vue from 'vue';
import PreferencesInputBlock from '../block/preferences-input-block.vue';
import Tag from '@common/filter-tag/tag.vue';
import NumbersDropdown from '@common/dropdown/drop-down-number.vue';
import LabelCheckBox from '@common/checkbox/label-checkbox.vue';
import Slider from '@common/slider/slider.vue';
import Icon1 from '@components/svg/car.vue';
import Icon2 from '@components/svg/airplane.vue';

const sliderMarks = {
  '0': {
    label: 'Lowest Prices',
    labelStyle: {
      transform: 'translateX(0)',
    },
  },
  '33.3': 'Mid Range',
  '66.6': 'Best Experience',
  '100': {
    label: 'Luxury',
    labelStyle: {
      transform: 'translateX(-32px)',
    },
  },
};

export default Vue.extend({
  name: 'ItineraryPreferencesTravelers',
  components: {
    PreferencesInputBlock,
    NumbersDropdown,
    LabelCheckBox,
    Tag,
    Slider,
  },
  props: {},
  data() {
    return {
      Icon1,
      Icon2,
      sliderValue: 33,
      sliderValue2: 0,
      sliderValueRange: [33, 66],
      sliderMarks,
    };
  },
  methods: {
    onOptionSelected(/* selectName: string */) {
      // console.log(selectName);
    },
    selectedCheckboxOptions(/*value: string*/) {
      // console.log(value);
    },
    handleSliderChange(value: number) {
      // console.log('handleSliderChange', value);
      this.sliderValue = value;
    },
    handleSliderChange2(value: number) {
      // console.log('handleSliderChange2', value);
      this.sliderValue2 = value;
    },
    handleSliderChange3(value: number[]) {
      // console.log('handleSliderChange3', value);
      this.sliderValueRange = value;
    },
  },
});
